import { useParams } from 'react-router-dom';
import { BibleReader } from '../features/bible/components/reader/bibleReader';
import { bibleService } from '../shared/services/bibleService';
import { useEffect, useState } from 'react';

export default function BiblePage() {
  const { book, chapter } = useParams();
  const [bookNumber, setBookNumber] = useState('1');

  useEffect(() => {
    const getBookNumber = async () => {
      if (book) {
        try {
          const { number } = await bibleService.getBookInfo(book);
          setBookNumber(number);
        } catch (error) {
          console.error('Error getting book number:', error);
          setBookNumber('1');
        }
      }
    };
    getBookNumber();
  }, [book]);

  return <BibleReader initialBook={bookNumber} initialChapter={chapter || '1'} />;
}